import React from "react";
import { useAuth0 } from "@auth0/auth0-react";
import { Button } from './button'

const LoginButton = () => {
  const { loginWithRedirect } = useAuth0();

  const handleLogin = async () => {
    await loginWithRedirect({
      appState: {
        returnTo: "/home",
      },
      authorizationParams: {
        screen_hint: "signup",
      },
    });
  };

  return <Button onClick={handleLogin}>Log In</Button>;
};

export default LoginButton;